<script>
  import {optimizeStore}              from '../../../stores/results/optimize-store';
  import {results5LimitedStore}       from '../../../stores/results/results-5-limited-store';
  import {sortByMultipleColumnsStore} from '../../../stores/results/sort-by-multiple-columns-store';
  import HelpButton                   from '../../help-button/help-button.svelte';

  $: counts = $results5LimitedStore.counts;

  const helps = {
    optimization: {
      topic: 'Results Optimization',
      description: 'A vehicle is suboptimal if it has a disadvantage (lower value for a statistic) but no advantage (higher value for a different statistic) compared to another vehicle.'
    },
    limiting: {
      topic: 'Results Limiting',
      description: 'The number of Results is limited to avoid an impractically long list. If you have a lot of matches, be more demanding with your statistic values. ;)'
    },
    sorting: {
      topic: 'Results Sorting',
      description: 'You can sort your Results by statistic value in descending order, by clicking the table headers. Shift-click to sort by multiple values.'
    }
  };

  $: matchesTerm = () => {
    return counts.filtered === 1 ? 'match' : 'matches';
  };
</script>

<style>
  #results-notes {
    width: 750px;
  }
</style>

<template lang="pug" src="./results-notes.pug"></template>
